import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  searchBaskets,
  selectBaskets,
} from '@epicuro-next/state/basket-switch-state';
import { select, Store } from '@ngrx/store';
import { BasketSlim } from 'graphql-api/baskets-api-interfaces';
import { map } from 'rxjs/operators';

import { basketManagerInfoToBasketSlim } from './map-basket-manager-info/map-basket-manager-info-to-basket-slim';

@Component({
  selector: 'epc-baskets-list',
  templateUrl: './baskets-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BasketsListComponent implements OnInit {
  @Input() public activeBasketId: string;
  @Input() public loading = false;
  @Input() public allLoaded = false;
  @Input()
  public set searchTerm(search: string) {
    if (search !== undefined) {
      this.store.dispatch(searchBaskets({ refNumber: search }));
    }
  }

  public baskets$ = this.store.pipe(
    select(selectBaskets),
    map(basketManagerInfoToBasketSlim),
  );

  constructor(private store: Store) {}

  public ngOnInit() {
    this.store.dispatch(searchBaskets({}));
  }

  public isActive(basketId: string) {
    return this.activeBasketId === basketId.replace(/-/g, '');
  }

  public onScroll() {
    if (!this.loading && !this.allLoaded) {
      this.store.dispatch(searchBaskets({}));
    }
  }

  public trackByBasketId(_: number, basket: BasketSlim) {
    return basket.id;
  }
}
